<div class="card__section" *ngIf="errors.length > 0">
  <div class="row">
    <div class="columns">
      <h4 class="typography--subheader">Error Details</h4>
    </div>
  </div>
  <div class="table" role="table">
    <span role="rowgroup">
      <span class="table__row table__row--header" role="row">
        <span class="table__cell table__cell--quarter" role="columnheader">#</span>
        <span class="table__cell table__cell--quarter" role="columnheader">Row</span>
        <span class="table__cell table__cell--quarter table__cell--align-left" role="columnheader">Field</span>
        <span class="table__cell table__cell--tripple table__cell--align-left" role="columnheader">Error</span>
      </span>
    </span>
    <div role="rowgroup">
      <span class="table__row" role="row" *ngFor="let error of pagedErrors; let i = index">
        <span class="table__cell table__cell--quarter" role="cell">{{ (currentPage - 1) * pageSize + i + 1 }}</span>
        <span class="table__cell table__cell--quarter" role="cell">{{ error.rowIndex }}</span>
        <span class="table__cell table__cell--quarter table__cell--align-left" role="cell">{{ getFieldLabel(error.field) }}</span>
        <span class="table__cell table__cell--triple table__cell--align-left" role="cell">{{ error.errorMessage }}</span>
      </span>
    </div>
  </div>
  <generic-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="errors.length"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></generic-pagination>
</div>